import {
  CREATE_SUBSCRIPTION,
  GET_ALL_USER_SUBSCRIPTIONS_WITH_BENEFITS,
  GET_PLAN_DETAILS_BY_ID,
  INITIATE_CALL_FOR_PARTNER,
} from "graphql/profiles";
import {
  CreateUserSubscription,
  CreateUserSubscriptionVariables,
} from "graphql/types/CreateUserSubscription";
import {
  GetAllUserSubscriptionsWithPlanBenefitsV2,
  GetAllUserSubscriptionsWithPlanBenefitsV2Variables,
} from "graphql/types/GetAllUserSubscriptionsWithPlanBenefitsV2";
import {
  GetOneApollo,
  GetOneApolloVariables,
} from "graphql/types/GetOneApollo";
import {
  GetPlanDetailsByPlanId,
  GetPlanDetailsByPlanIdVariables,
} from "graphql/types/GetPlanDetailsByPlanId";
import {
  PaymentStatus,
  one_apollo_store_code,
} from "graphql/types/globalTypes";
import React, { useEffect, useState } from "react";
import {
  checkUserType,
  getCarePlan,
  getCircleUserSubscriptions,
  getMembershipObject,
  getPatientAttributes,
  getPatientDetails,
  isBrowser,
} from "helpers/commonHelpers";
import {
  initiateCallForPartner,
  initiateCallForPartnerVariables,
} from "graphql/types/initiateCallForPartner";
import { useAuth, useLoginPopupState } from "hooks/authHooks";

import AphButton from "components/web-ui-components/AphButton";
import AphDialog from "components/web-ui-components/AphDialog";
import AphDialogClose from "components/web-ui-components/AphDialogClose";
import CircularProgress from "@material-ui/core/CircularProgress";
import { ConfigOneApolloData } from "strings/AppConfig";
import { GET_ONE_APOLLO } from "graphql/medicines";
import { ICONS_PATHS } from "helpers/constants";
import { LazyIntersection } from "./lib/LazyIntersection";
import { SignedinState } from "./enums/SignedinState";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Typography from "@material-ui/core/Typography";
import { clientRoutes } from "helpers/clientRoutes";
import { createMedia } from "@artsy/fresnel";
import dynamic from "next/dynamic";
import { eventTracking } from "clevertapTracking";
import makeStyles from "@material-ui/styles/makeStyles";
import { useApolloClient } from "react-apollo-hooks";
import useCircle from "hooks/useCircle";
import { useDiagnosticsCart } from "./Tests/DiagnosticsCartProvider";
import { useGlobalDiagnosticsCart } from "./Tests/DiagnosticsCartProviderGlobal";
import { useRouter } from "next/router";
const iconPathsCircle = ICONS_PATHS.slice(0, 2);
const DynamicCareBenifitsCard = dynamic(
  () =>
    import("components/CareBenifitsCard").then(
      (defaultComponent) => defaultComponent.default
    ),
  { ssr: false }
);

const { MediaContextProvider, Media } = createMedia({
  breakpoints: {
    sm: 0,
    md: 768,
    lg: 1024,
    xl: 1192,
  },
});

const useStyles = makeStyles((theme: Theme) => {
  return {
    card: {
      boxShadow: " 0px 5px 20px rgba(128, 128, 128, 0.3)",
      borderRadius: 10,
      height: 0,
      backgroundSize: "cover",
      backgroundPosition: "0 0",
      backgroundRepeat: "no-repeat",
      cursor: "pointer",
      width: "100%",
      position: "relative",
      paddingTop: "18.75%",
      overflow: "hidden",
      "& >img": {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
      },
      [theme.breakpoints.down("xs")]: {
        paddingTop: "43.75%",
      },
    },
    cardForDetails: {
      height: 92,
      [theme.breakpoints.down("xs")]: {
        backgroundSize: "100% !important",
      },
    },
    cardContent: {
      position: "absolute",
      width: "100%",
      top: "7%",
      left: "4%",
      bottom: 0,
      [theme.breakpoints.down("xs")]: {
        top: "10px",
        left: "10px",
      },
      "& h2": {
        fontSize: 28,
        lineHeight: "36px",
        fontWeight: 700,
        color: "#fff",
        textTransform: "uppercase",
        display: "flex",
        alignItems: "center",
        width: "75%",
        [theme.breakpoints.down("sm")]: {
          fontSize: 14,
          lineHeight: "20px",
          width: "75%",
        },
      },
      "& p": {
        display: "inline-block",
        fontSize: 13,
        fontWeight: 600,
        "& span": {
          fontWeight: 700,
        },
      },
    },
    cardContentForDetails: {
      padding: "10px 14px",
    },
    dialogContent: {
      "@media only screen and (max-height: 600px)": {
        height: 450,
        overflow: "auto",
      },
      "@media only screen and (max-height: 400px)": {
        height: 350,
      },
    },
    dialogHeader: {
      padding: 20,
      boxShadow: " 0px 6.19589px 24.7836px rgba(128, 128, 128, 0.3)",
      textAlign: "center",
      "& h3": {
        fontSize: 20,
        fontWeight: 600,
        lineHeight: "25px",
      },
      "& p": {
        fontSize: 10,
        lineHeight: "13px",
      },
    },
    slickCase: {
      width: "80%",
      padding: 20,
      [theme.breakpoints.down("sm")]: {
        padding: 10,
      },
      [theme.breakpoints.down("xs")]: {
        display: "flex",
        alignItems: "center",
        justifycontent: "center",
      },
    },
    btnContainer: {
      textAlign: "center",
      padding: "10px 0",
      "& button": {
        display: "block",
        margin: "0 auto",
        marginBottom: 7,
      },
    },
    secondaryBtn: {
      boxShadow: "none",
      color: "#FC9916",
      marginBottom: 10,
    },
    dialogBox: {
      [theme.breakpoints.down("sm")]: {
        maxWidth: "90% !important",
        margin: "0 auto",
      },
    },
    circleHcContent: {
      padding: 16,
      textAlign: "center",
      background: `url("${process.env.NEXT_PUBLIC_247_CDN_URL}/images/circle-hp-bg.png") no-repeat 0 -20px`,
      backgroundSize: "contain",
      "& img": {
        width: "100%",
        margin: "30px 0",
        [theme.breakpoints.down("sm")]: {
          width: "80%",
        },
      },
      "& h2": {
        fontSize: 32,
        lineHeight: "42px",
        color: "#FC9916",
        fontWeight: 700,
      },
      "& p": {
        fontSize: 16,
        lineHeigt: "21px",
        margin: "0 0 20px",
      },
    },
    circleFact: {
      fontSize: 14,
      lineHeight: "18px",
      color: "#979797",
      textAlign: "center",
      paddingBottom: 10,
      "& span": {
        fontWeight: 600,
        display: "block",
      },
    },
    upgradeContainer: {
      display: "inline-block",
      width: "auto",
      background: "#fff",
      padding: "5px 9px 3px 10px",
      borderRadius: 5,
      margin: 0,
      position: "absolute",
      bottom: "8px",
      left: 0,
      boxShadow: "0px 3.47748px 6.95496px rgba(0, 0, 0, 0.2)",
      "& + p": {
        color: "#fff",
        fontSize: "12px",
        display: "inline-block",
        [theme.breakpoints.down("xs")]: {
          fontSize: "9px",
          display: "block",
          position: "relative",
          paddingLeft: 0,
        },
      },
      "& h3": {
        fontSize: 18,
        fontWeight: 700,
        color: "#FC9916",
        display: "flex",
        alignItems: "center",
        textTransform: "uppercase",
        [theme.breakpoints.down("sm")]: {
          fontSize: 10,
          lineHeight: "20px",
        },
        "& img": {
          marginLeft: "5px",
          [theme.breakpoints.down("xs")]: {
            margin: 0,
            width: "29%",
            marginLeft: "2px",
          },
        },
      },
      "& p": {
        fontSize: 13,
        fontWeight: 600,
        [theme.breakpoints.down("sm")]: {
          fontSize: 10,
          position: "relative",
          top: -10,
        },
        "& span": {
          fontWeight: 700,
        },
      },
    },
    upgradeContainerForDetails: {
      bottom: "10px",
      width: "auto",
      margin: "0px 0 0px 0px",
      padding: "2px 10px",
      "& h3": {
        fontSize: "12px",
        "& img": {
          margin: 0,
          width: "20%",
          marginLeft: "2px",
        },
      },
      "& p": {
        fontSize: "10px",
      },
    },
    connectDoctorContent: {
      display: "flex",
      alignItems: "flex-start",
      flexWrap: "wrap",
    },
    cdDetails: {
      width: "50%",
      padding: 12,
      "& img": {
        margin: "0 auto 10px",
      },
      "& h5": {
        fontSize: 12,
        color: "#00B38E",
        linHeight: "16px",
        "& span": {
          fontWeight: 700,
        },
      },
    },
    p0: {
      padding: 0,
    },
    callNote: {
      fontSize: 12,
      linrHeight: "16px",
      "& span": {
        display: "block",
      },
    },
    subHeaderText: {
      fontSize: 16,
      fontWeight: 600,
      display: "inline-block",
    },
    subText: {
      position: "absolute",
      bottom: 20,
      [theme.breakpoints.down("xs")]: {
        position: "absolute !important",
        bottom: 13,
      },
    },
  };
});

export interface SlideProps {
  bannerClass?: any;
  bgRegular?: string | null;
  bgResponsive?: string | null;
  headLine?: React.ReactNode | null;
  headLine2?: React.ReactNode | null;
  headLine3?: React.ReactNode | null;
  subHeaderText1?: React.ReactNode | null;
  subHeaderText2?: React.ReactNode | null;
  button?: boolean | null;
  buttonLeadText?: React.ReactNode | null;
  buttonSubText?: string | null;
  subText?: string | null;
  buttonAction?: string | null;
  buttonActionType?: string | null;
  buttonURL?: string | null;
  bannerAction?: string | null;
  showHealthCredits?: string | null;
  defaultCarePlanPrice?: number | null;
  redirectToCareLanding?: boolean;
  showPharmaWebView?: boolean;
  showTestsWebView?: boolean;
  testSubText?: React.ReactNode | null;
  isUserCare?: boolean;
  landingPageName?: string | null;
  setSuccessMessage?: (successMessage: object) => void;
  bannerInfo?: any;
  position?: number;
}

export const Slide: React.FC<SlideProps> = (props) => {
  const classes = useStyles({});
  const {
    bannerClass,
    bgRegular,
    headLine,
    headLine2,
    headLine3,
    subHeaderText1,
    subHeaderText2,
    button,
    buttonLeadText,
    buttonSubText,
    subText,
    buttonAction,
    buttonActionType,
    buttonURL,
    showHealthCredits,
    defaultCarePlanPrice,
    testSubText,
    isUserCare,
    landingPageName,
    setSuccessMessage,
    bannerInfo,
    position,
  } = props;
  const [circlePlanPurchased, setCirclePlanPurchased] = useState<boolean>(
    false
  );
  const [circlePlanOneTouch, setCirclePlanOneTouch] = useState<boolean>(false);
  const [circlePlans, setCirclePlans] = useState<boolean>(false);
  const [modifiedText, setModifiedText] = useState<string>("");
  const [modifiedButtonText, setModifiedButtonText] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [oneApolloHCsResponse, setOneApolloHCsResponse] = useState<any>({});
  const [selection, setSelection] = useState(
    isBrowser() && localStorage.getItem("CAREPlan")
      ? JSON.parse(localStorage.getItem("CAREPlan"))
      : ""
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [userSubscriptionId, setUserSubscriptionId] = useState<any>("");
  const [carePlans, setCarePlans] = useState([]);
  const { isCircleExpired } = useCircle();

  const [callDoctorPopup, setCallDoctorPopup] = useState<boolean>(false);
  const [exotelBenefitId, setExotelBenefitId] = useState<string>("");
  const {
    diagnosticsCartItems,
    setShowCircleMembershipPopup,
  } = useDiagnosticsCart();
  const { currentPatient, isSignedIn } = useAuth();
  const { diagnosticAddress } = useGlobalDiagnosticsCart();
  const patientDetails = getPatientDetails(currentPatient);
  const client = useApolloClient();
  const history = useRouter();
  const { setIsLoginPopupVisible: setLoginPopupVisible } = useLoginPopupState();

  const currentCircleSub = getCircleUserSubscriptions();
  let userType = checkUserType();
  const carePlan = getCarePlan();
  // const isSmallScreen = useMediaQuery("(max-width: 576px)");
  const currentPath = history.asPath;
  const testsDetailPage = "test-details";
  const [exotelCallPrompt, setExotelCallPrompt] = useState<{
    DCOTOR_CONNECTING: string;
    CONNECT_ERROR: string;
  }>(null);

  const returnUserReadableDate = (isoDate: string) => {
    let date = new Date(isoDate);
    return date.toLocaleDateString("en-GB");
  };
  useEffect(() => {
    const loadConstants = async () => {
      const constants = await import("helpers/constants").then(
        (client) => client.EXOTEL_CALL_PROMPT
      );
      setExotelCallPrompt(constants);
    };
    loadConstants();
  }, []);

  useEffect(() => {
    const userSubscriptions: any = localStorage.getItem("userSubscriptions")
      ? JSON.parse(localStorage.getItem("userSubscriptions"))
      : {};
    setUserSubscriptionId(
      userSubscriptions &&
        userSubscriptions.APOLLO &&
        userSubscriptions.APOLLO.length > 0 &&
        userSubscriptions.APOLLO[0] &&
        userSubscriptions.APOLLO[0]._id
    );
  }, []);

  const handleButtonClick = (buttonAction: string) => {
    const eventData = {
      ...getPatientAttributes(patientDetails),
      "Banner name": bannerInfo?.creative,
      position: position + 1,
      "Nav src": bannerInfo?.name + " " + bannerInfo?.id,
      "Page Name": currentPath,
    };
    eventTracking("Banner Clicked", eventData);
    switch (buttonAction) {
      case "BUY_CARE_PLAN":
        if (isSignedIn !== SignedinState.SIGNEDIN) {
          setLoginPopupVisible(true);
        } else if (diagnosticsCartItems?.length) {
          setShowCircleMembershipPopup(true);
        } else {
          oneApolloHCsResponse &&
          oneApolloHCsResponse.availableHC > defaultCarePlanPrice
            ? setCirclePlanOneTouch(true)
            : setCirclePlans(true);
        }

        break;
      case "CARE_DETAILS":
        window.location.href = `${clientRoutes.careLanding()}?utm_source=Landing Home Page banners`;
        break;
      case "MEMBERSHIP_DETAIL_CIRCLE":
        window.location.href = `${clientRoutes.careMembership()}?utm_source=Landing Home Page banners`;
        break;
      case "CALL_EXOTEL_API":
        handleDoctorCall();
        break;
      case "UPGRADE_CIRCLE":
        setCirclePlans(true);
        break;
      case "MEMBERSHIP_DETAIL":
        if (buttonActionType === "REDIRECT")
          window.location.href = clientRoutes.partnersHdfc();
        break;
      case "PHARMACY_LANDING":
        if (buttonActionType === "REDIRECT")
          window.location.href = process.env.NEXT_PUBLIC_PHARMACY_FRONTEND_URL;
        break;
      case "DIAGNOSTICS_LANDING":
        /* WEB ENGAGE TRACKING */
        const circle_subs = localStorage.getItem("userSubscriptions")
          ? JSON.parse(localStorage.getItem("userSubscriptions"))
          : {};
        const patientDetails = getPatientDetails(currentPatient);
        const clevertapData = {
          ...getPatientAttributes(patientDetails),
          Circle_user:
            circle_subs?.APOLLO && circle_subs?.APOLLO[0]?.status === "active"
              ? true
              : false,
          Source: "247 Home banner",
          City: diagnosticAddress?.cityName || "Not available",
          CityId: diagnosticAddress?.cityID || "Not available",
        };
        eventTracking("Diagnostic landing page viewed", clevertapData);
        if (buttonActionType === "REDIRECT")
          window.location.href = clientRoutes.tests();
        break;
      case "DIAGNOSTICS_LANDING":
        if (buttonActionType === "REDIRECT") {
          /* WEB ENGAGE TRACKING */
          const circle_subs = localStorage.getItem("userSubscriptions")
            ? JSON.parse(localStorage.getItem("userSubscriptions"))
            : {};
          const clevertapData = {
            ...getPatientAttributes(patientDetails),
            Circle_user:
              circle_subs?.APOLLO && circle_subs?.APOLLO[0]?.status === "active"
                ? true
                : false,
            Source: "247 Home banner",
            City: diagnosticAddress?.cityName || "Not available",
            CityId: diagnosticAddress?.cityID || "Not available",
          };
          eventTracking("Diagnostic landing page viewed", clevertapData);
          window.location.href = clientRoutes.tests();
        }
        break;
      case "SPECIALITY_LISTING":
        window.location.href = clientRoutes.specialties(buttonURL);
        break;
      case "PROHEALTH_LANDING":
        localStorage?.removeItem("proHealthSelectedHospitalId");
        localStorage?.removeItem("proHealthSelectedHospitalName");
        localStorage?.removeItem("proHealthSelectedCityName");
        localStorage?.removeItem("proHealthSelectedHospitalUnitType");
        window.location.href = clientRoutes.apolloProHealthCategories();
        break;
      case "ABSOLUTE_URL":
        window.location.href = buttonURL?.includes("/deal")
          ? `${buttonURL}?source=Consult Homepage`
          : buttonURL;
        break;
      default:
    }
  };

  // Removed HDFC Doc on Call as it was moved from Slider, Now Doc on call works only wtih Apollo Circle
  const handleDoctorCall = () => {
    client
      .query<
        GetAllUserSubscriptionsWithPlanBenefitsV2,
        GetAllUserSubscriptionsWithPlanBenefitsV2Variables
      >({
        query: GET_ALL_USER_SUBSCRIPTIONS_WITH_BENEFITS,
        variables: {
          mobile_number: localStorage.getItem("mobile_num"),
        },
        fetchPolicy: "no-cache",
      })
      .then((response) => {
        let benefitsApollo =
          response.data.GetAllUserSubscriptionsWithPlanBenefitsV2.response
            .APOLLO &&
          response.data.GetAllUserSubscriptionsWithPlanBenefitsV2.response
            .APOLLO[0] &&
          response.data.GetAllUserSubscriptionsWithPlanBenefitsV2.response
            .APOLLO[0].benefits;
        if (benefitsApollo) {
          benefitsApollo.map((item: any) => {
            if (item.cta_action.type == "CALL_API") {
              if (item.attribute_type.remaining > 0) {
                setExotelBenefitId(item._id);
                setCallDoctorPopup(true);
              } else {
                setSuccessMessage({
                  message: `Hey, looks like you have exhausted the monthly usage limit for this benefit. If you feel this is an error, please raise a ticket on the Help section.`,
                });
              }
            }
          });
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const initiateExotelCall = (mobileNumber: string, benefitId: string) => {
    client
      .query<initiateCallForPartner, initiateCallForPartnerVariables>({
        query: INITIATE_CALL_FOR_PARTNER,
        variables: {
          mobileNumber: mobileNumber,
          benefitId: benefitId,
          userSubscriptionId: userSubscriptionId,
        },
        fetchPolicy: "no-cache",
      })
      .then((response) => {
        response.data.initiateCallForPartner.success
          ? setSuccessMessage({
              message: exotelCallPrompt.DCOTOR_CONNECTING,
            })
          : setSuccessMessage({
              message: exotelCallPrompt.CONNECT_ERROR,
            });
        setCallDoctorPopup(false);
      })
      .catch((error) => {
        console.log(error);
        setCallDoctorPopup(false);
        setSuccessMessage({
          message: exotelCallPrompt.CONNECT_ERROR,
        });
      });
  };

  useEffect(() => {
    if (currentPatient && currentPatient.id) {
      setLoading(true);
      client
        .query<GetOneApollo, GetOneApolloVariables>({
          query: GET_ONE_APOLLO,
          variables: {
            patientId: currentPatient ? currentPatient.id : "",
          },
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          if (res && res.data && res.data.getOneApolloUser) {
            setOneApolloHCsResponse(res.data.getOneApolloUser);
            setModifiedText(
              showHealthCredits + res.data.getOneApolloUser.availableHC
            );
            if (res.data.getOneApolloUser.availableHC >= defaultCarePlanPrice) {
              setModifiedButtonText(
                buttonSubText.split("₹").join("") + " health credits"
              );
            }
          }
        })
        .catch((e) => {
          console.log(ConfigOneApolloData.apolloHcsError, e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [currentPatient]);

  useEffect(() => {
    if (isSignedIn === SignedinState.SIGNEDIN) {
      setLoading(true);
      client
        .query<GetPlanDetailsByPlanId, GetPlanDetailsByPlanIdVariables>({
          query: GET_PLAN_DETAILS_BY_ID,
          variables: {
            plan_id: "CIRCLEPlan",
          },
        })
        .then((response) => {
          setCarePlans(
            response.data.GetPlanDetailsByPlanId.response.plan_summary
          );
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [isSignedIn]);

  const createCircleSubscriptionWithHC = () => {
    setLoading(true);
    client
      .query<CreateUserSubscription, CreateUserSubscriptionVariables>({
        query: CREATE_SUBSCRIPTION,
        variables: {
          userSubscription: {
            mobile_number: currentPatient.mobileNumber,
            FirstName: currentPatient.firstName,
            plan_id: "CIRCLEPlan",
            sub_plan_id: selection && selection.subPlanId,
            storeCode: one_apollo_store_code.WEBCUS,
            payment_reference: {
              amount_paid: 0,
              payment_status: PaymentStatus.TXN_SUCCESS,
              purchase_via_HC: true,
              HC_used: selection && selection.currentSellingPrice,
            },
            transaction_date_time: new Date().toISOString(),
          },
        },
        fetchPolicy: "no-cache",
      })
      .then((response) => {
        setEndDate(
          returnUserReadableDate(
            response.data &&
              response.data.CreateUserSubscription &&
              response.data.CreateUserSubscription.response.end_date
          )
        );
        setCirclePlanOneTouch(false);
        setCirclePlans(false);
        setCirclePlanPurchased(true);
        const dummyItem = JSON.stringify({
          APOLLO: [{ subscriptionActivated: true }],
        });
        localStorage.setItem("userSubscriptions", dummyItem);
      })
      .catch((error) => {
        console.error("error in CreateUserSubscription", error);
        alert("Error creating User Subscription" + error);
      })
      .finally(() => {
        localStorage.removeItem("defaultPack");
        setLoading(false);
      });
  };

  const returnBG = (bgRegular: string) => {
    if (bgRegular) {
      let index1 = bgRegular.lastIndexOf("/");
      let index2 = bgRegular.lastIndexOf(".");
      let responsiveName = "mweb_" + bgRegular.substring(index1 + 1, index2);
      return (
        bgRegular.substring(0, index1 + 1) +
        responsiveName +
        bgRegular.substring(index2)
      );
    }
  };

  return (
    <>
      <MediaContextProvider>
        <Media at="sm">
          <div
            className={`${bannerClass ? bannerClass : classes.card} ${
              currentPath.includes(testsDetailPage)
                ? classes.cardForDetails
                : ""
            }`}
            onClick={() => {
              handleButtonClick(buttonAction);
            }}
          >
            <LazyIntersection
              src={returnBG(bgRegular)}
              alt="Placeholder banner"
              fallbackImage={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/placeholder-banner.jpg`}
            />
            <div
              className={`${classes.cardContent} ${
                currentPath.includes(testsDetailPage)
                  ? classes.cardContentForDetails
                  : ""
              }`}
            >
              {headLine && <Typography component="h2">{headLine}</Typography>}
              <>
                {headLine2 && (
                  <Typography component="h2">{headLine2}</Typography>
                )}
                {headLine3 && (
                  <Typography component="h2">{headLine3}</Typography>
                )}
              </>
              {subHeaderText1 && (
                <div className={classes.subHeaderText}>{subHeaderText1}</div>
              )}
              {subHeaderText2 && (
                <div className={classes.subHeaderText}>{subHeaderText2}</div>
              )}
              {button && (
                <div
                  className={`${classes.upgradeContainer} ${
                    currentPath.includes(testsDetailPage)
                      ? classes.upgradeContainerForDetails
                      : ""
                  }`}
                  onClick={() => {
                    handleButtonClick(buttonAction);
                  }}
                >
                  <Typography component="h3">{buttonLeadText}</Typography>
                  {buttonSubText && <Typography>{buttonSubText}</Typography>}
                </div>
              )}
              {subText && !currentPath.includes(testsDetailPage) && (
                <Typography className={classes.subText}>{subText}</Typography>
              )}

              {testSubText && !currentPath.includes(testsDetailPage) && (
                <Typography>{testSubText}</Typography>
              )}
            </div>
          </div>
        </Media>
        <Media greaterThan="sm">
          <div
            className={`${bannerClass ? bannerClass : classes.card} ${
              currentPath.includes(testsDetailPage)
                ? classes.cardForDetails
                : ""
            }`}
            onClick={() => {
              handleButtonClick(buttonAction);
            }}
          >
            <LazyIntersection
              src={bgRegular}
              alt="Placeholder banner"
              fallbackImage={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/placeholder-banner.jpg`}
            />
            <div
              className={`${classes.cardContent} ${
                currentPath.includes(testsDetailPage)
                  ? classes.cardContentForDetails
                  : ""
              }`}
            >
              {headLine && <Typography component="h2">{headLine}</Typography>}
              {!button ? (
                <>
                  {headLine2 && (
                    <Typography component="h2">{headLine2}</Typography>
                  )}
                  {headLine3 && (
                    <Typography component="h2">{headLine3}</Typography>
                  )}
                </>
              ) : (
                (headLine2 || headLine3) && (
                  <Typography component="h2">
                    {(headLine2 ? headLine2 : "") +
                      " " +
                      (headLine3 ? headLine3 : "")}
                  </Typography>
                )
              )}
              {subHeaderText1 && (
                <div className={classes.subHeaderText}>{subHeaderText1}</div>
              )}
              {subHeaderText2 && (
                <div className={classes.subHeaderText}>{subHeaderText2}</div>
              )}
              {button && (
                <div
                  className={`${classes.upgradeContainer} ${
                    currentPath.includes(testsDetailPage)
                      ? classes.upgradeContainerForDetails
                      : ""
                  }`}
                  onClick={() => {
                    handleButtonClick(buttonAction);
                  }}
                >
                  <Typography component="h3">{buttonLeadText}</Typography>
                  {buttonSubText && <Typography>{buttonSubText}</Typography>}
                </div>
              )}
              {subText && !currentPath.includes(testsDetailPage) && (
                <Typography className={classes.subText}>{subText}</Typography>
              )}

              {testSubText && !currentPath.includes(testsDetailPage) && (
                <Typography>{testSubText}</Typography>
              )}
            </div>
          </div>
        </Media>
      </MediaContextProvider>

      {/* 3 Circles Dialog to select the plan */}
      <AphDialog open={circlePlans} maxWidth="md" className={classes.dialogBox}>
        <AphDialogClose onClick={() => setCirclePlans(false)} title={"Close"} />
        <div className={classes.dialogContent}>
          <div className={classes.dialogHeader}>
            <Typography component="h3">Circle Membership Plans</Typography>
          </div>
          <div>
            <DynamicCareBenifitsCard
              setSelection={setSelection}
              selectedPlan={selection}
              context={landingPageName}
            />
            <div className={classes.btnContainer}>
              <AphButton
                className={classes.secondaryBtn}
                onClick={() => {
                  history.push(
                    `${
                      isCircleExpired
                        ? clientRoutes.careMembership()
                        : clientRoutes.careLanding()
                    }?utm_source=LandingHomePageBanner`
                  );
                }}
              >
                Know More
              </AphButton>

              {selection && (
                <AphButton
                  color="primary"
                  onClick={() => {
                    const patientDetails = getPatientDetails(currentPatient);
                    const eventInfo = {
                      ...patientDetails,
                      customer_id: currentPatient?.id || "",
                      user_type: userType,
                      plan_id:
                        currentCircleSub?.["plan_id"] || "No Subscription",
                      duration_in_month: selection?.durationInMonth,
                      Price: selection?.currentSellingPrice,
                      special_price_enabled: selection?.special_price_enabled,
                      navigation_source: currentPath.includes("lab-tests")
                        ? "Diagnostic Home Page Banner"
                        : "Landing Home Page Banners",
                      circle_start_date: currentCircleSub?.["start_date"]
                        ? `$D_${new Date(
                            currentCircleSub?.["start_date"]
                          ).getTime()}`
                        : "No Subscription",
                      circle_end_date: currentCircleSub?.["end_date"]
                        ? `$D_${new Date(
                            currentCircleSub?.["end_date"]
                          ).getTime()}`
                        : "No Subscription",
                    };
                    eventTracking(
                      "Circle Payment Page Viewed (Standalone circle purchase page)",
                      eventInfo
                    );
                    localStorage.setItem("CAREPlan", JSON.stringify(selection));
                    oneApolloHCsResponse.availableHC >
                    selection.currentSellingPrice
                      ? createCircleSubscriptionWithHC()
                      : history.push(clientRoutes.payCare());
                  }}
                  disabled={selection ? false : true}
                  style={selection ? {} : { backgroundColor: "grey" }}
                >
                  {oneApolloHCsResponse.availableHC >
                  selection.currentSellingPrice
                    ? `Upgrade for ${selection.currentSellingPrice} Health Credits`
                    : `Upgrade with ₹${selection.currentSellingPrice}`}
                </AphButton>
              )}
            </div>
            <Typography className={classes.circleFact}>
              #CircleFact: On an average Circle members
              <span>save upto ₹848 every month</span>
            </Typography>
          </div>
        </div>
      </AphDialog>

      {/* OneTouch Flow Consent Dialogg */}
      <AphDialog open={circlePlanOneTouch} className={classes.dialogBox}>
        <AphDialogClose
          onClick={() => setCirclePlanOneTouch(false)}
          title={"Close"}
        />
        <div className={classes.dialogContent}>
          <div className={classes.circleHcContent}>
            <span className="icon-circle">
              {iconPathsCircle.map((item, index) => {
                return <span key={index} className={item} />;
              })}
            </span>
            <Typography component="h2">Great Choice!</Typography>
            <Typography>
              We are upgrading you to Circle with your Health Credits to the
              amount of {defaultCarePlanPrice}HC
            </Typography>
            <div className={classes.btnContainer}>
              <AphButton
                color="primary"
                onClick={() => {
                  createCircleSubscriptionWithHC();
                }}
              >
                {loading ? <CircularProgress /> : `Sure Go Ahead !`}
              </AphButton>
              <AphButton
                className={classes.secondaryBtn}
                onClick={() => {
                  setCirclePlanOneTouch(false);
                  setCirclePlans(true);
                }}
              >
                Use Another Payment Method
              </AphButton>
            </div>
          </div>
        </div>
      </AphDialog>

      {/* OneTouch Flow Payment Confirmation */}
      <AphDialog open={circlePlanPurchased} className={classes.dialogBox}>
        <AphDialogClose
          onClick={() => {
            setCirclePlanPurchased(false);
            window.location.reload();
          }}
          title={"Close"}
        />
        <div className={classes.dialogContent}>
          <div className={classes.circleHcContent}>
            <span className="icon-circle">
              {iconPathsCircle.map((item, index) => {
                return (
                  <span
                    key={index}
                    className={item}
                    style={{ display: "inline-block" }}
                  />
                );
              })}
            </span>

            <Typography component="h2">Circle Membership Activated!</Typography>
            <Typography>Valid Till : {endDate}</Typography>
            {/* <Typography>
              Health Credits remaining: {oneApolloHCsResponse.availableHC - defaultCarePlanPrice}
            </Typography> */}
            <div className={classes.btnContainer}>
              <AphButton
                color="primary"
                onClick={() => {
                  window.location.href = clientRoutes.welcome();
                }}
              >
                Return To Homepage
              </AphButton>
            </div>
          </div>
        </div>
      </AphDialog>

      <AphDialog open={callDoctorPopup} maxWidth="sm">
        <div className={classes.dialogContent}>
          <div className={classes.dialogHeader}>
            <Typography component="h3">Connect to the Doctor </Typography>
            <Typography>
              Please follow the steps to connect to Doctor{" "}
            </Typography>
          </div>
          <div className={classes.connectDoctorContent}>
            <div className={classes.cdDetails}>
              <img
                src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/call-incoming.svg`}
                alt="Call incoming"
              />
              <Typography component="h5">
                Answer the call from <span>‘040-482-17258’</span> to connect.
              </Typography>
            </div>
            <div className={classes.cdDetails}>
              <img
                src={`${process.env.NEXT_PUBLIC_247_CDN_URL}/images/hdfc/call-outgoing.svg`}
                alt="Call Outgoing"
              />
              <Typography component="h5">
                The same call will connect to the Doctor.
              </Typography>
            </div>
            <div className={classes.cdDetails}>
              <span className="icon-group" />
              <Typography component="h5">
                Wait for the Doctor to connect over the call.
              </Typography>
            </div>
            <div className={classes.cdDetails}>
              <Typography className={classes.callNote}>
                <span>*Note : </span>Your personal phone number will not be
                shared.
              </Typography>
            </div>
          </div>
          <div className={classes.btnContainer}>
            <AphButton onClick={() => setCallDoctorPopup(false)}>
              Cancel
            </AphButton>
            <AphButton
              color="primary"
              onClick={() => {
                initiateExotelCall(
                  localStorage.getItem("mobile_num"),
                  exotelBenefitId
                );
              }}
            >
              Proceed To Connect
            </AphButton>
          </div>
        </div>
      </AphDialog>
    </>
  );
};

export default Slide;
